module.exports = __webpack_public_path__ + "resources/img/bg_request_m.2d1a7ac5e2370728d182a2c9fdf50dea.png";